import { GlobalEventsManager } from './gobal-events-manager';
import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
 
import { AppConfig } from '../app.config';
import { AuthGuard } from '../auth.guard';
 
@Injectable()
export class AuthenticationService {
    constructor(private http: Http, private config: AppConfig,
                private _guard: AuthGuard,
                private globalEventsManager: GlobalEventsManager) { }
 
    login(username: string, password: string) {
        return this.http.post(this.config.apiUrl + '/api-token-auth/', { username: username, password: password })
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let user = response.json();
                if (user && user.token) {
                  this.globalEventsManager.showNavBar.emit(true);
                  // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                }
            });
    }
 
    logout() {
        // remove user from local storage to log user out
        this.globalEventsManager.hideNavBar.emit(true);
        localStorage.removeItem('currentUser');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts